module.exports = __webpack_public_path__ + "img/13.dc7fa5ed.png";